  export const Success = () =>{

    return (
        <div className="container">
            <br />
            <h1>Thank you for your purchase!</h1>
            <br />
       </div>
    )
  
}
  
  export default Success;
